export default {
  metrics: {
    nrr: {
      title: 'NRR % (trimestral)',
      description:
        '(Ingresos por suscripción {{currentMonth}} (T{{currentQuarter}}) + Ingresos por tarifa de servicio {{currentMonth}} (T{{currentQuarter}})) / (Ingresos por suscripción {{prevMonth}} (fin de T{{prevQuarter}}) + Ingresos por tarifa de servicio {{prevMonth}} (fin de T{{prevQuarter}})) * 100',
    },
    upgrades: 'Mejoras de cuenta',
    downgrades: 'Rebajas de cuenta',
    gte_c_tier: 'Cuentas ≥ nivel C',
    churn: 'Baja (suspendida)',
    offers_turned_on: 'Ofertas activadas',
    flyers_sent: 'Volantes enviados',
    on_google_ads_trial: 'En prueba de Google Ads',
    converted_google_ads: 'Google Ads convertidos con éxito',
    first_time_500_monthly_sales: 'Primer mes de €500',
    '14_days_no_sales': '14 días activo, sin ingresos',
  },
  details: {
    address: 'Dirección',
    subscriptions: 'Suscripciones actuales',
    best_sales: 'Mejor mes histórico',
    sales: 'Ventas de {{month}}',
    tier: 'Nivel de {{month}}',
    live_from: 'Fecha de lanzamiento',
    owner_phone: 'Teléfono del propietario',
    owner_email: 'Email del propietario',
    owner: 'Nombre del propietario',
    name: 'Restaurante',
    export_csv: 'Exportar CSV',
  },
  publish: 'Publicar',
  unpublish: 'Despublicar',
};
